module.exports = __webpack_public_path__ + "static/media/office_digital.ba020edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office_digital.jpg
// module id = 264
// module chunks = 0